import { createAction } from 'redux-actions';
import * as types from './types';

export const neverShowGuideAgain = createAction(types.NEVER_SHOW_GUIDE_AGAIN);
